<template>
  <div class="content">
    <div>
      <div class="md-layout-item md-size-100 text-right">
        <md-button class="md-raised md-success mr-4" @click="blogModal('new', {})">New Blog</md-button>
      </div>
    </div>
    <div class="md-layout">
      <div v-for="blog in allBlogs" class="blog_item md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-25">
        <stats-card >
          <template slot="header">
            <md-menu md-direction="bottom-start">
              <md-icon md-menu-trigger class="blog_icon">more_vert</md-icon>
              <md-menu-content>
                <md-menu-item @click="blogModal('edit', blog)">Edit</md-menu-item>
                <md-menu-item @click="deleteBlog(blog.id)">Delete</md-menu-item>
              </md-menu-content>
            </md-menu>
          </template>
          <template slot="content">
            <img
                :src="blog.image_url"
                :alt="blog.title"
                style="width: 100%; height: auto; border-radius: 8px;"
            />
          </template>
          <template slot="content">
            <h4 class="title py-2">
              {{blog.title}}
            </h4>
            <p class="category truncate-text">{{blog.short_description}}</p>
          </template>
          <template slot="footer">
            <div class="stats">
              <p class="truncate-text">{{blog.long_description}}</p>
            </div>
          </template>
        </stats-card>
      </div>
    </div>
<!-- dialog-->
    <md-dialog :md-active.sync="showDialog" class="custom-dialog md-size-100">
      <md-dialog-title>{{modalText.title}} Blog</md-dialog-title>
      <div class="md-layout-item md-small-size-100 md-size-100">
        <div class="media_main">
          <div
              class="dropzone_container"
              @dragover="dragover"
              @dragleave="dragleave"
              @drop="drop"
              :style="isDragging && 'border-color: green;'"
          >
            <input
                type="file"
                multiple
                name="file"
                id="fileInput"
                class="dropzone_input"
                @change="onChange"
                ref="file"
                accept=".pdf,.jpg,.jpeg,.png"
            />
            <label for="fileInput" class="dropzone_label">
              <div v-if="isDragging">Release to drop files here.</div>
              <div v-else>Drop file here or <u>click here</u> to upload.</div>
            </label>
          </div>

          <div class="preview_container mt-2" v-if="modalData.image">
            <div class="preview_card">
              <div class="preview_card-item">
                <img class="preview_img"  :src="generateURL(modalData.image)"  />
              </div>
            </div>
          </div>
          <span class="text-danger" v-if="modalErrors.image">
            {{modalErrors.image[0]}}
          </span>
        </div>
      </div>


      <div class="md-layout-item md-small-size-100 md-size-100 px-4">
        <md-field class="mb-1">
          <label>Title</label>
          <md-input v-model="modalData.title" type="text" required md-placeholder="Title"></md-input>
        </md-field>
        <span class="text-danger" v-if="modalErrors.title">
          {{modalErrors.title[0]}}
        </span>
      </div>

      <div class="md-layout-item md-small-size-100 md-size-100 px-4">
        <md-field maxlength="6" class="mb-1">
          <label>Short description</label>
          <md-textarea v-model="modalData.short_description" required placeholder="Short description"></md-textarea>
        </md-field>
        <span class="text-danger" v-if="modalErrors.short_description">
          {{modalErrors.short_description[0]}}
        </span>
      </div>

      <div class="md-layout-item md-small-size-100 md-size-100 px-4">
        <md-field maxlength="6" class="mb-1">
          <label>Long description</label>
          <md-textarea v-model="modalData.long_description" required placeholder="Long description"></md-textarea>
        </md-field>
        <span class="text-danger" v-if="modalErrors.long_description">
          {{modalErrors.long_description[0]}}
        </span>
      </div>
      <md-dialog-actions class="m-3">
        <md-button class="md-secondary" @click="showDialog = false">Close</md-button>
        <md-button class="md-success" @click="onConfirm()" >{{modalText.btnText}} Blog</md-button>
      </md-dialog-actions>
    </md-dialog>
<!-- dialog-->

    <!-- del   -->
    <md-dialog :md-active.sync="showDelDialog" class="custom-dialog">
      <md-dialog-title>Delete Blog</md-dialog-title>
      <div class="md-layout-item md-small-size-100 md-size-100">
        <h4>Are you sure you want to delete this blog?</h4>
        <br>
        <p>This action cannot be undone and the blog details will be permanently removed.</p>
      </div>
      <md-dialog-actions>
        <md-button class="md-secondary" @click="showDelDialog = false">Close</md-button>
        <md-button class="md-primary" @click="onConfirmDelete()">Delete</md-button>
      </md-dialog-actions>
    </md-dialog>
    <!--    -->
  </div>
</template>

<script>
import {StatsCard} from "@/components";
import {mapActions} from "vuex";

export default {
  name: "AdminBlogs",
  data() {
    return {
      isDragging: false,
      files: [],
      showDialog: false,
      showDelDialog: false,
      modalText: {
        title: '',
        btnText: ''
      },
      modalData: {
        id: '',
        title: '',
        short_description: '',
        long_description: '',
        image: {},
        image_url: null,
        mode: ''
      },
      modalErrors: [],
      allBlogs: [],
      delBlogId: null,
    }
  },
  components: {
    StatsCard
  },
  created() {
    this.getAllBlogs()
  },
  methods: {
    ...mapActions(['createEditBlog', 'getAdminBlogs', 'removeAdminBlog']),
    getAllBlogs() {
      this.getAdminBlogs()
      .then(res => {
        this.allBlogs = res.data.data
      })
    },
    blogModal(mode, item) {
      console.log(item, 'hhhh')
      this.showDialog = true
      if(mode == 'new' ) {
        this.modalData.id = ''
        this.modalData.title = ''
        this.modalData.short_description = ''
        this.modalData.long_description = ''
        this.modalData.image = ''
        this.modalData.mode = 'new'
        this.modalText.title = 'New'
        this.modalText.btnText = 'Create'
      } else {
        this.modalText.title = 'Edit'
        this.modalText.btnText = 'Edit'
        this.modalData.mode = 'edit'
        this.modalData.id = item.id
        this.modalData.title = item.title
        this.modalData.short_description = item.short_description
        this.modalData.long_description = item.long_description
        this.modalData.image = item.image_url
        this.modalData.image_url = item.image_url
      }
    },
    onConfirm() {
      this.modalErrors = []
      this.createEditBlog(this.modalData)
          .then(res => {
            this.showDialog = false
            this.getAllBlogs()
          })
          .catch(err => {
            if (err.response && err.response.status === 422 && err.response.data && err.response.data.errors) {
              this.modalErrors = err.response.data.errors
            } else if (err.response && err.response.data) {
              const message = err.response.data.message || 'The image failed to upload.'
              if (this.$notify) {
                this.$notify({
                  message,
                  icon: 'error',
                  horizontalAlign: 'center',
                  verticalAlign: 'top',
                  type: 'danger'
                })
              } else {
                alert(message)
              }
            } else {
              const message = 'The image failed to upload.'
              if (this.$notify) {
                this.$notify({
                  message,
                  icon: 'error',
                  horizontalAlign: 'center',
                  verticalAlign: 'top',
                  type: 'danger'
                })
              } else {
                alert(message)
              }
            }
          })


    },
    generateURL(file) {
      if (file instanceof Blob) {
        return URL.createObjectURL(file);
      } else {
        return file
      }
    },
    onChange() {
      const incomingFiles = Array.from(this.$refs.file.files);
      if (!incomingFiles.length) return;

      const firstFile = incomingFiles[0];

      // Validate image type/size before upload
      if (!this.validateImage(firstFile)) {
        // reset input if invalid
        this.$refs.file.value = '';
        return;
      }

      const fileExist = this.files.some((r) =>
          incomingFiles.some(
              (file) => file.name === r.name && file.size === r.size
          )
      );
      if (fileExist) {
        this.showMessage = true;
        alert("New upload contains files that already exist");
      } else {
        this.files.push(...incomingFiles);
        // ✅ Assign the first image for preview
        this.modalData.image = firstFile;
        if (this.modalErrors.image) {
          this.$delete(this.modalErrors, 'image')
        }
      }
    },
    dragover(e) {
      e.preventDefault();
      this.isDragging = true;
    },
    dragleave() {
      this.isDragging = false;
    },
    drop(e) {
      e.preventDefault();
      this.$refs.file.files = e.dataTransfer.files;
      this.onChange();
      this.isDragging = false;
    },
    validateImage(file) {
      const maxMB = 2;
      const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];

      if (!allowedTypes.includes(file.type)) {
        if (this.$notify) {
          this.$notify({
            message: 'Only JPG and PNG formats are allowed',
            icon: 'error',
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: 'warning'
          })
        } else {
          alert('Only JPG and PNG formats are allowed')
        }
        return false;
      }

      const fileSizeMB = file.size / (1024 * 1024);
      if (fileSizeMB > maxMB) {
        if (this.$notify) {
          this.$notify({
            message: `Image size must be less than ${maxMB} MB`,
            icon: 'error',
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: 'warning'
          })
        } else {
          alert(`Image size must be less than ${maxMB} MB`)
        }
        return false;
      }

      return true;
    },
    deleteBlog(id) {
      this.delBlogId = id
      this.showDelDialog = true
    },
    onConfirmDelete() {
      this.removeAdminBlog(this.delBlogId)
          .then(res => {
            this.showDelDialog = false
            this.getAllBlogs()
            console.log(res, 'removeAdminBlog')
          })
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep .md-card-content {
  text-align: unset !important;
  & img {
    height: 200px !important;
  }
}
::v-deep .md-card-header {
  float: right !important;
}
::v-deep .blog_item {
  display: flex;
  height: 490px !important;
}
::v-deep .md-dialog-container {
  max-width: 650px;
  width: 100%;
  max-height: 100%;
  overflow-y: auto;
}
::v-deep .md-card-header {
  padding: 8px !important;
  margin-bottom: 5px !important;
  cursor: pointer;
  & .blog_icon {
    width: 20px !important;
    height: 20px !important;
  }
}
.media {
  &_main {
    display: flex;
    flex-direction: column;
    align-items: center;
    & .preview {
      &_container {
        display: flex;
      }
      &_card {
        display: flex;
        border: 1px solid #a2a2a2;
        padding: 10px;
        margin-bottom: 10px;
        width: 400px;
        height: 240px;
        position: relative;
        &-item {
          width: 100%;
        }
        &_input {
          &-item {
            padding: 5px 0;
          }
        }
        &-close {
          position: absolute;
          width: 24px;
          height: 24px;
          border-radius: 50%;
          border: 2px solid lightgray;
          top: 5px;
          right: 5px;
        }
      }
      &_img {
        width: 100%;
        height: 220px;
        border-radius: 5px;
        border: 1px solid #a2a2a2;
        background-color: #a2a2a2;
      }
    }
    & .dropzone {
      &_container {
        padding: 50px;
        background: #f7fafc;
        border: 2px dashed #9e9e9e;
        width: 400px;
        height: 100px;
      }
      &_input {
        opacity: 0;
        overflow: hidden;
        position: absolute;
        width: 1px;
        height: 1px;
      }
      &_label {
        font-size: 18px;
        display: block;
        cursor: pointer;
        text-align: center;
      }
    }
  }
}
//.truncate-text {
//  overflow: hidden;
//  text-overflow: ellipsis;
//  white-space: nowrap;
//  display: block;
//}
.truncate-text {
  display: -webkit-box;
  -webkit-line-clamp: 2; /* Number of lines */
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>
